const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Sobre",
    to: "/sobre",
  },
  {
    text: "Nossos Serviços",
    to: "/nossos-servicos",
  },
  {
    text: "Contato",
    to: "/contato",
  },
];

export { server, menu };
